import { Stack, Text } from "@fluentui/react";
import "./Navbar.css";

type NavbarProps = {
  toggleDialog: () => void;
  showVoting: boolean;
  userName: string;
  Logo: string;
};

export function Navbar({ toggleDialog, showVoting, userName, Logo }: NavbarProps) {
  return (
    <>
      <Stack
        horizontal
        horizontalAlign="space-between"
        verticalAlign="center"
        className="Navigation"
      >
        <a href={window.location.origin} className="Link">
          <Stack horizontal verticalAlign="center">
            <img src={Logo} alt="Logo IOZ" className="logo" />
            <Text variant="xxLarge">Project Estimator</Text>
          </Stack>
        </a>
        <Stack horizontal horizontalAlign="end" tokens={{ childrenGap: 40 }}>
          <Text variant="xLarge" onClick={() => toggleDialog()} className="navigationTextLink">
            History
          </Text>
          {showVoting && (
            <Text
              variant="xLarge"
              className="navigationTextLink"
              style={{ marginLeft: "20px" }}
              onClick={() => {
                navigator.clipboard.writeText(window.location.href);
              }}
            >
              Teilen
            </Text>
          )}
          <Text variant="xLarge" className="Username">
            {userName}
          </Text>
        </Stack>
      </Stack>
    </>
  );
}
